import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { get } from 'lodash-es'
import { Alert } from 'react-bootstrap'

import { getModal$ } from 'syft-acp-core/store/modals/selectors'
import { hideModal } from 'syft-acp-core/store/modals/actions'
import { Modal } from 'syft-acp-core/components/Modal'
import { formatFullName } from 'syft-acp-util/formatting'
import UserLine from 'syft-acp-core/components/UserAvatar/UserLine'

import './CancelBookingConfirmationModal.css'

class CancelBookingConfirmationModal extends React.PureComponent {
  static propTypes = {
    item: PropTypes.shape({
      modalName: PropTypes.string,
      options: PropTypes.object,
      onClose: PropTypes.func,
      isShown: PropTypes.bool,
    }).isRequired,
    dispatch: PropTypes.func.isRequired,
  }

  modalClose = () => {
    this.props.dispatch(hideModal(this.props.item.modalName))
  }

  handleContinueCancel = () => {
    const { options } = this.props.item
    const { onConfirm } = options

    if (onConfirm) {
      onConfirm()
    }
    this.modalClose()
  }

  render() {
    const { options, isShown } = this.props.item
    const { shiftBooking } = options

    if (!shiftBooking) {
      return null
    }

    const { worker, syft_compensation, syft_unpaid_hours_compensation } = shiftBooking
    const workerName = worker ? formatFullName(worker) : 'Unknown Worker'
    const avatarUUID = get(worker, 'profile_picture.uuid', '')

    const fcActive = Boolean(syft_compensation)
    const chActive = Boolean(syft_unpaid_hours_compensation)

    return (
      <Modal
        header="Cancel booking confirmation"
        isShown={isShown}
        onClose={this.modalClose}
        onConfirm={this.handleContinueCancel}
        confirmationText="Continue cancelling"
        cancelText="Go back"
        canSubmit={true}
      >
        <div className="cancel-booking-confirmation-modal">
          <div className="booking-info-section">
            <h4>Booking information</h4>
            <div className="worker-info">
              <UserLine avatarUUID={avatarUUID} name={workerName} />
            </div>
          </div>

          <div className="flags-status-section">
            <h4>Current flag status</h4>

            <div className="flag-status">
              <div className={`flag-indicator fc ${fcActive ? 'active' : 'inactive'}`}>
                <span className="flag-label">FC - Flex Compensation</span>
                <span className={`status ${fcActive ? 'enabled' : 'disabled'}`}>
                  {fcActive ? 'ENABLED' : 'DISABLED'}
                </span>
              </div>
              {fcActive && (
                <Alert bsStyle="info" className="flag-explanation">
                  <strong>Effect:</strong> No billing items will be created for this booking and thus{' '}
                  <strong>the client will not be billed regardless of any other criteria</strong>.
                </Alert>
              )}
            </div>

            <div className="flag-status">
              <div className={`flag-indicator ch ${chActive ? 'active' : 'inactive'}`}>
                <span className="flag-label">CH - Compensation Hours</span>
                <span className={`status ${chActive ? 'enabled' : 'disabled'}`}>
                  {chActive ? 'ENABLED' : 'DISABLED'}
                </span>
              </div>
              {chActive && (
                <Alert bsStyle="info" className="flag-explanation">
                  <strong>Effect:</strong> Show up pay (SUP) pay and billing items may be created to meet role
                  minimum compensation hours. The worker will be paid and the client will be billed.
                </Alert>
              )}
            </div>
          </div>

          <div className="cancellation-warning">
            <Alert bsStyle="danger">
              <strong>Warning:</strong> Cancelling this booking will remove the worker from this shift. This
              action cannot be undone. This is your last chance to configure the CH & FC flags.
            </Alert>
          </div>
        </div>
      </Modal>
    )
  }
}

export default connect(state => ({
  item: getModal$(state.modals)('cancelBookingConfirmationModal'),
}))(CancelBookingConfirmationModal)
